import { render, staticRenderFns } from "./profileDocumentsDynamicComponent.vue?vue&type=template&id=16d7a31e&scoped=true&"
import script from "./profileDocumentsDynamicComponent.vue?vue&type=script&lang=js&"
export * from "./profileDocumentsDynamicComponent.vue?vue&type=script&lang=js&"
import style0 from "./profileDocumentsDynamicComponent.vue?vue&type=style&index=0&id=16d7a31e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7a31e",
  null
  
)

export default component.exports